import React, { useState } from 'react';
import { useDispatch } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { signin } from '../redux-toolkit/Slice/loginSlice';
import { ADMIN_LOGIN } from '../redux-toolkit/ApiEndpoint';

import { toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

import Cookies from 'js-cookie';

const Login = ({ onLoginSuccess }) => {
    const [email, setEmail] = useState('');
    const [password, setPassword] = useState('');
    const navigate = useNavigate();
    const dispatch = useDispatch();

    const handleSubmit = async (e) => {
        e.preventDefault();

        const loginData = {
            email: email,
            password: password,
        };

        try {
            const response = await dispatch(signin({
                endpoint: ADMIN_LOGIN,
                payload: loginData
            })).unwrap();

            // If login is successful and token is set
            if (response.token) {
                Cookies.set('token', response.token);
                onLoginSuccess(); // Trigger re-render in App
                toast.success('Login successful! ');
                navigate('/product');
            }
           
        } catch (error) {
            console.error('Login failed:', error);
            toast.error(error?.message || 'Login failed. Please try again.');
        }
    };

    const toggleSignup = () => {
        navigate("/signup");
    };

    return (
        <div className="page-padding py-100">
            <div className="container">
                <div className="row justify-content-center">
                    <div className="col-lg-8">
                        <div className="row text-center">
                            <h2 className="title">Login</h2>
                            <div className="col-12">
                                <hr />
                            </div>
                        </div>
                        <form onSubmit={handleSubmit} className='row'>

                            <div className="col-lg-6 mb-4">
                                <label className="mb-2">Email:</label>
                                <input
                                    type="email"
                                    value={email}
                                    onChange={(e) => setEmail(e.target.value)}
                                    required
                                    className="form-control"
                                />
                            </div>
                            <div className="col-lg-6 mb-4">
                                <label className="mb-2">Password:</label>
                                <input
                                    type="password"
                                    value={password}
                                    onChange={(e) => setPassword(e.target.value)}
                                    required
                                    className="form-control"
                                />
                            </div>
                            <div className="col-lg-12 text-center">
                                <button type="submit" className="btn-grad d-inline-flex align-items-center justify-content-center text-uppercase mt-2 border-0">
                                    Login
                                </button>
                                
                            </div>
                        </form>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default Login;
